import { Injectable, inject } from '@angular/core';

import { AppInfoConfig, CookieService, LastKnownProductService, NavigationService, PlatformProductMapConfig } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductResolverService {
    private readonly navigationService = inject(NavigationService);
    private readonly lastKnownProductService = inject(LastKnownProductService);
    private readonly appConfig = inject(AppInfoConfig);
    private readonly platformProductMapConfig = inject(PlatformProductMapConfig);
    private readonly cookieService = inject(CookieService);

    async getProduct() {
        const lastKnownProduct = this.lastKnownProductService.get();
        const lastKnowProductValue = lastKnownProduct.name === 'unknown' ? '' : lastKnownProduct.name;
        await firstValueFrom(this.platformProductMapConfig.whenReady);
        const platformProductValue = this.platformProductMapConfig.platformProductMap?.[lastKnowProductValue];
        const productId =
            this.navigationService.location.search.get('forCashierProductId') ||
            this.navigationService.location.search.get('productId') ||
            platformProductValue ||
            this.cookieService.get('registrationProduct') ||
            this.appConfig.product;

        return productId.toUpperCase();
    }
}
